import { useEffect, useState, KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";

export default function PasswordProtection() {
  const [isLoading, setLoading] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [msg, setMsg] = useState<string>("");
  const navigation = useNavigate();

  useEffect(() => {
    document.getElementById("protectionPasswordId")?.focus();
  }, []);

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isLoading) {
      confirm();
    }
  };

  const confirm = async () => {
    if (!password) {
      setMsg("Please enter the password");
      setTimeout(() => {
        setMsg("");
      }, 5000);
      return;
    }

    setLoading(true);

    try {
      const protectionPassword = process.env.REACT_APP_PROTECTION_PASSWORD;
      
      if (!protectionPassword) {
        console.error('Protection password not set in environment');
        setMsg("Configuration error");
        setLoading(false);
        return;
      }

      if (password === protectionPassword) {
        sessionStorage.setItem("isProtectionVerified", "true");
        setLoading(false);
        navigation("/");
      } else {
        setLoading(false);
        setPassword("");  // Clear the input on wrong password
        setMsg("Invalid password");
        setTimeout(() => {
          setMsg("");
        }, 5000);
      }
    } catch (error) {
      console.error('Error during password verification:', error);
      setLoading(false);
      setMsg("An error occurred");
      setTimeout(() => {
        setMsg("");
      }, 5000);
    }
  };

  return (
    <div className="w-full h-full flex flex-col px-[35px] sm:px-[33px] md:pt-[70px] pt-[15px] md:pb-[50px] pb-[30px] md:text-[12px] text-[16px]">
      <div className="flex-1 flex flex-col max-[479px]:justify-start md:justify-start justify-center gap-y-[30px]">
        <div className="block md:hidden">
          <div className="hidden xs:block">
            <div className="flex-1 flex flex-col gap-y-[20px] md:text-[14px] text-[16px]">
              <span className="text-center">YEWS IS PRESENTED IN PORTRAIT MODE</span>
            </div>
          </div>
        </div>
        <div className="md:block max-[500px]:block w-full block xs:hidden md:text-[12px] text-[16px]">
          <div className="flex flex-col gap-y-[3.6px]">
            <span className="">Enter Password</span>
            <input
              placeholder="Password"
              id="protectionPasswordId"
              type="password"
              value={password}
              onChange={(evt) => setPassword(evt.target.value)}
              onKeyPress={handleKeyPress}
              className="mt-2 bg-transparent outline-none w-[100%] placeholder:text-black text-[16px] md:text-[12px]"
              autoComplete="off"
            />
            {isLoading ? (
              <span>Please wait...</span>
            ) : (
              <span className="cursor-pointer" onClick={confirm}>
                Submit
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex-row gap-x-[20px]">
        <span className="cursor-pointer">{msg && msg}</span>
      </div>
    </div>
  );
} 